import React, { Component } from "react";
import axios from "axios";
import { axiosConfig } from "../../../config/utility";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";

import {
  listSupplierAgreements,
  listSupplierAgreementsWithDefaults,
  listSupplierAgreementsArchived,
  getSupplierAgreement,
  submitAgreementDefaultSupplier,
  deleteAgreement,
  unarchiveSupplierAgreement,
} from "./../../../config/general_api_calls";

import $ from "jquery";
import DataTable from "../../../components/Tables/DataTable";
import DataTableExtended from "../../../components/Tables/DataTableExtended";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import { THEME_TEXT_COLOR, THEME_COLOR } from "./../../../config/config";

import Step1 from "../../../components/Agents/Step1";
import Step2 from "../../../components/Agents/Step2";
import Step3 from "../../../components/Agents/Step3";

import TextField from "../../../components/InputFields/TextField";
import SelectField from "../../../components/InputFields/SelectField";
import MutextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import StepWizard from "react-step-wizard";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import RestoreIcon from "@material-ui/icons/Restore";
import dateFormat, { masks } from "dateformat";
import localization from "../../../localization/enUS";
import UserPermissionHelper from "../../../components/Reseller/UserPermissionHelper";

const auth = new HelperClass();

class Agentagreement extends Component {
  constructor() {
    super();
    this.state = {
      agreementsData: [],
      errorMessaged: "",
      errorMessage: "",
      successMessaged: "",
      title: "",
      name: "",
      logo: "",
      agent_email: auth.getEmail(),
      delete_id: "",
      agent_password: "",
      c_password: "",
      description: "",
      successMessage: "",
      tableLoader: true,
      domain: "",
      step: 1,
      dnsList: [],
      a_ip: "",
      is_verified: 0,
      archivedagreementsData: [],
      defaultErrorMessage: "",
      defaultSuccessMessage: "",
      default_action_button: false,
      default_title: "",
      default_button_text: "",
      default_body_text: "",
      default_agreement_accountno: "",
      default_value_to_change: "",
      permissionsState: [],
      permission_add_agreement: 0,
      permission_edit_agreement: 0,
      permission_set_default: 0,
      permission_delete_agreement: 0,
      agreement_view: "",
      retrieve_id: "",
      retrieveErrorMessage: "",
      retrieveSuccessMessage: "",
      retrieve_action_button: false,
      columns: [
        { name: "Sequence #" },
        {
          name: "Title",
          options: {
            customBodyRender: (value, tableMeta) => {
              return <div>{this.titleText(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Status",
          options: {
            customBodyRender: (value, tableMeta) => {
              return <div>{this.statusText(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Mandatory",
          options: {
            customBodyRender: (value, tableMeta) => {
              return <div>{this.signupText(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Type",
          options: {
            customBodyRender: (value, tableMeta) => {
              return <div>{this.typeText(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Date Added",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{value}</div>;
            },
          },
        },
        // {
        //   name: "Actions",
        //   options: {
        //     customBodyRender: (value, tableMeta) => {
        //       return (
        //         <div>
        //           <div
        //             className="nk-tb-col nk-tb-col-tools"
        //             style={{ padding: "0px" }}
        //           >
        //             <ul className="nk-tb-actions gx-1">
        //               <li>
        //                 <div className="drodown">
        //                   <a
        //                     href="#"
        //                     className="dropdown-toggle btn btn-icon btn-outline-light"
        //                     data-toggle="dropdown"
        //                   >
        //                     <em className="icon ni ni-more-h"></em>
        //                   </a>
        //                   <div className="dropdown-menu dropdown-menu-right">
        //                     <ul className="link-list-opt no-bdr">
        //                       <li>
        //                         <a
        //                           data-toggle="tooltip"
        //                           data-placement="left"
        //                           onClick={() =>
        //                             this.addMenuHistory(
        //                               "/agents/editagreement/" +
        //                                 tableMeta.rowData[6]
        //                             )
        //                           }
        //                           title="Edit Agreement"
        //                           style={{ cursor: "pointer" }}
        //                           disabled={
        //                             this.props.is_msa_signed === "No" ||
        //                             this.props.defaultSettings === "missing"
        //                               ? true
        //                               : false
        //                           }
        //                         >
        //                           <em className="icon ni ni-edit"></em>
        //                           <span>Edit Agreement</span>
        //                         </a>
        //                       </li>
        //                       {tableMeta.rowData[8] &&
        //                       tableMeta.rowData[8] === "duplicate" ? (
        //                         <li>
        //                           <a
        //                             data-toggle="tooltip"
        //                             data-placement="left"
        //                             onClick={() =>
        //                               this.setAgreementDefault(
        //                                 value,
        //                                 tableMeta.rowData[8]
        //                               )
        //                             }
        //                             title="Default agreements will be applied to newly registered clients."
        //                             style={{ cursor: "pointer" }}
        //                             disabled={
        //                               this.props.is_msa_signed === "No" ||
        //                               this.props.defaultSettings === "missing"
        //                                 ? true
        //                                 : false
        //                             }
        //                           >
        //                             <em className="icon ni ni-link-group"></em>
        //                             <span>Make Default</span>
        //                           </a>
        //                         </li>
        //                       ) : (
        //                         <li>
        //                           <a
        //                             data-toggle="tooltip"
        //                             data-placement="left"
        //                             onClick={() =>
        //                               this.setAgreementDefault(
        //                                 value,
        //                                 tableMeta.rowData[8]
        //                               )
        //                             }
        //                             title="Agreements that are not set as default will not be assigned to newly registered clients."
        //                             style={{ cursor: "pointer" }}
        //                             disabled={
        //                               this.props.is_msa_signed === "No" ||
        //                               this.props.defaultSettings === "missing"
        //                                 ? true
        //                                 : false
        //                             }
        //                           >
        //                             <em className="icon ni ni-link-group"></em>
        //                             <span>Unset Default</span>
        //                           </a>
        //                         </li>
        //                       )}
        //                       <li>
        //                         <a
        //                           onClick={() =>
        //                             this.deleteAlert(tableMeta.rowData[6])
        //                           }
        //                           style={{ cursor: "pointer" }}
        //                           data-toggle="tooltip"
        //                           data-placement="top"
        //                           title="Delete Agreement"
        //                           disabled={
        //                             this.props.is_msa_signed === "No" ||
        //                             this.props.defaultSettings === "missing"
        //                               ? true
        //                               : false
        //                           }
        //                         >
        //                           <em className="icon ni ni-trash"></em>
        //                           <span>Delete Agreement</span>
        //                         </a>
        //                       </li>
        //                     </ul>
        //                   </div>
        //                 </div>
        //               </li>
        //             </ul>
        //           </div>
        //         </div>
        //       );
        //     },
        //   },
        // },
        {
          name: "Actions",
          label: "Actions",
          options: {
            stickyRight: true,
            customBodyRender: (value, tableMeta) => {
              const isDisabledGlobally =
                this.props.is_msa_signed === "No" ||
                this.props.defaultSettings === "missing";

              const agreementId = tableMeta.rowData[6];
              const defaultStatus = tableMeta.rowData[8]; // "duplicate" or something else

              return (
                <>
                  {this.state.permissionsState &&
                  this.state.permissionsState.length > 0 &&
                  (this.state.permission_edit_agreement === 1 ||
                    this.state.permission_set_default === 1 ||
                    this.state.permission_delete_agreement === 1) ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        minHeight: 36,
                      }}
                    >
                      {/* Edit Agreement */}
                      {this.state.permissionsState &&
                      this.state.permissionsState.length > 0 &&
                      this.state.permission_edit_agreement === 1 ? (
                        <Tooltip title="Edit Agreement" placement="top">
                          <a
                            onClick={() =>
                              this.addMenuHistory(
                                "/suppliers/editagreement/" + agreementId
                              )
                            }
                            style={{
                              cursor: isDisabledGlobally
                                ? "not-allowed"
                                : "pointer",
                              pointerEvents: isDisabledGlobally
                                ? "none"
                                : "auto",
                            }}
                            disabled={isDisabledGlobally}
                          >
                            <em
                              className="icon ni ni-edit text-primary"
                              style={{
                                fontSize: 20,
                                opacity: isDisabledGlobally ? 0.3 : 1,
                              }}
                            />
                          </a>
                        </Tooltip>
                      ) : null}

                      {/* Make / Unset Default */}
                      {this.state.permissionsState &&
                      this.state.permissionsState.length > 0 &&
                      this.state.permission_set_default === 1 ? (
                        <Tooltip
                          title={
                            defaultStatus === "duplicate"
                              ? "Make Default – Default agreements will be applied to newly registered suppliers."
                              : "Unset Default – Agreements that are not set as default will not be assigned to newly registered suppliers."
                          }
                          placement="top"
                        >
                          <a
                            onClick={() =>
                              this.setAgreementDefault(value, defaultStatus)
                            }
                            style={{
                              cursor: isDisabledGlobally
                                ? "not-allowed"
                                : "pointer",
                              pointerEvents: isDisabledGlobally
                                ? "none"
                                : "auto",
                            }}
                            disabled={isDisabledGlobally}
                          >
                            <em
                              className="icon ni ni-link-group text-secondary"
                              style={{
                                fontSize: 20,
                                paddingLeft: 5,
                                borderLeft:
                                  this.state.permission_edit_agreement === 1
                                    ? "1px solid rgb(0 0 0 / 87%)"
                                    : "none",
                                opacity: isDisabledGlobally ? 0.3 : 1,
                              }}
                            />
                          </a>
                        </Tooltip>
                      ) : null}

                      {/* Delete Agreement */}
                      {this.state.permissionsState &&
                      this.state.permissionsState.length > 0 &&
                      this.state.permission_delete_agreement === 1 ? (
                        <Tooltip title="Delete Agreement" placement="top">
                          <a
                            onClick={() => this.deleteAlert(agreementId)}
                            style={{
                              cursor: isDisabledGlobally
                                ? "not-allowed"
                                : "pointer",
                              pointerEvents: isDisabledGlobally
                                ? "none"
                                : "auto",
                            }}
                            disabled={isDisabledGlobally}
                          >
                            <em
                              className="icon ni ni-trash text-danger"
                              style={{
                                fontSize: 20,
                                paddingLeft: 5,
                                borderLeft:
                                  this.state.permission_set_default === 1 ||
                                  this.state.permission_edit_agreement === 1
                                    ? "1px solid rgb(0 0 0 / 87%)"
                                    : "none",
                                opacity: isDisabledGlobally ? 0.3 : 1,
                              }}
                            />
                          </a>
                        </Tooltip>
                      ) : null}
                    </div>
                  ) : (
                    "---"
                  )}
                </>
              );
            },
          },
        },
        {
          name: "Archived",
          options: {
            display: "false",
            customBodyRender: (value, tableMeta) => {
              return <div>{this.statusText(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Created As",
          options: {
            display: "false",
          },
        },
      ],
      columnsExtended: [
        { name: "Title" },
        {
          name: "Status",
          options: {
            customBodyRender: (value, tableMeta) => {
              return <div>{this.statusTextArchive(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Mandatory",
          options: {
            customBodyRender: (value, tableMeta) => {
              return <div>{this.signupTextArchive(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Type",
          options: {
            customBodyRender: (value, tableMeta) => {
              return <div>{this.typeTextArchive(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Date Added",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{value}</div>;
            },
          },
        },
        {
          name: "Actions",
          options: {
            stickyRight: true,
            customBodyRender: (value, tableMeta) => {
              const isDisabledGlobally =
                this.props.is_msa_signed === "No" ||
                this.props.defaultSettings === "missing";
              const agreementId = tableMeta.rowData[5];

              return (
                <>
                  {this.state.permissionsState &&
                  this.state.permissionsState.length > 0 &&
                  (this.state.permission_edit_agreement === 1 ||
                    this.state.permission_delete_agreement === 1) ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        minHeight: 36,
                      }}
                    >
                      {this.state.permission_edit_agreement === 1 ? (
                        <Tooltip title="View Agreement" placement="top">
                          <a
                            onClick={() => this.viewArchivedAgreement(agreementId)}
                            style={{
                              cursor: isDisabledGlobally
                                ? "not-allowed"
                                : "pointer",
                              pointerEvents: isDisabledGlobally
                                ? "none"
                                : "auto",
                              opacity: isDisabledGlobally ? 0.3 : 1,
                            }}
                            disabled={isDisabledGlobally}
                          >
                            <VisibilityIcon
                              style={{
                                fontSize: 20,
                                color: "#0d6efd",
                              }}
                            />
                          </a>
                        </Tooltip>
                      ) : null}

                      {this.state.permission_delete_agreement === 1 ? (
                        <Tooltip title="Retrieve Agreement" placement="top">
                          <a
                            onClick={() => this.retrieveAlert(agreementId)}
                            style={{
                              cursor: isDisabledGlobally
                                ? "not-allowed"
                                : "pointer",
                              pointerEvents: isDisabledGlobally
                                ? "none"
                                : "auto",
                              opacity: isDisabledGlobally ? 0.3 : 1,
                            }}
                            disabled={isDisabledGlobally}
                          >
                            <RestoreIcon
                              style={{
                                fontSize: 20,
                                color: "#198754",
                              }}
                            />
                          </a>
                        </Tooltip>
                      ) : null}
                    </div>
                  ) : (
                    "---"
                  )}
                </>
              );
            },
          },
        },
        {
          name: "Archived",
          options: {
            display: "false",
            customBodyRender: (value, tableMeta) => {
              return <div>{this.statusTextArchive(value, tableMeta)}</div>;
            },
          },
        },
      ],
      tableData: [],
    };
  }
  titleText = (value, tableMeta) => {
    let title = tableMeta.rowData[1];
    let is_archived = tableMeta.rowData[8];
    //console.log("titleText: ");
    if (is_archived === "duplicate") {
      return title;
    } else {
      return (
        <p>
          {title}
          {"  "}
          <Tooltip
            title="Default agreements will be applied to all newly added clients."
            placement="right"
          >
            <span className="badge badge-outline-primary">Default</span>
          </Tooltip>
        </p>
      );
    }
  };

  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };
  serviceSigning = async (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  async componentDidMount() {
    this.loadPermissions();
    const servicesResponce = await listSupplierAgreementsWithDefaults(
      auth.getAccount(),
      auth.getToken()
    );

    //console.log("Agreement Res: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        agreementsData: (servicesResponce.data.data || []).map((row) => {
          const newRow = [...row];
          newRow[5] = dateFormat(newRow[5], "mm-dd-yyyy");
          return newRow;
        }),
        tableLoader: false,
      });
    } else {
      //window.location.replace("/error");
    }
  }

  loadPermissions = () => {
    if (!this.props.userRoleItems) return;
    const canEdit = UserPermissionHelper.getAllRoles(
      this.props.userRoleItems,
      "agreements",
      "supplier_agreements"
    );
    // console.log("Can Edit Clients:", canEdit);

    this.setState({
      permissionsState: canEdit,
      permission_add_agreement: canEdit[0].add_agreement,
      permission_edit_agreement: canEdit[0].edit_agreement,
      permission_set_default: canEdit[0].set_default,
      permission_delete_agreement: canEdit[0].delete_agreement,
    });
    //console.log("Can Edit Clients:", canEdit);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.userRoleItems !== this.props.userRoleItems) {
      this.loadPermissions();
    }
  }

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy");
  };

  SupplierAgreementsArchivedFun = async () => {
    const servicesResponce = await listSupplierAgreementsArchived(
      auth.getAccount(),
      auth.getToken()
    );

    //console.log("Archived Agreement Res: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        archivedagreementsData: servicesResponce.data.data.map((row) => {
          const newRow = [...row];
          newRow[4] = dateFormat(newRow[4], "mm-dd-yyyy");
          return newRow;
        }),
        tableLoader: false,
      });
    } else {
      //window.location.replace("/error");
    }
  };

  publishText = (value, tableMeta) => {
    let is_published = tableMeta.rowData[1];
    if (is_published === 1) {
      return "Yes";
    } else {
      return "No";
    }
  };

  statusText = (value, tableMeta) => {
    let is_status = tableMeta.rowData[2];
    let is_archived = tableMeta.rowData[7];
    if (is_status === 1 && is_archived === 0) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Active
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-danger">
          <em className="icon ni ni-na"></em> Inactive
        </span>
      );
    }
  };

  statusTextArchive = (value, tableMeta) => {
    let is_status = tableMeta.rowData[1];
    let is_archived = tableMeta.rowData[6];
    if (is_status === 1 && is_archived === 0) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Active
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-danger">
          <em className="icon ni ni-na"></em> Inactive
        </span>
      );
    }
  };

  signupText = (value, tableMeta) => {
    let is_signup = tableMeta.rowData[3];
    if (is_signup === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-primary">
          <em className="icon ni ni-na"></em> No
        </span>
      );
    }
  };

  signupTextArchive = (value, tableMeta) => {
    let is_signup = tableMeta.rowData[2];
    if (is_signup === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-primary">
          <em className="icon ni ni-na"></em> No
        </span>
      );
    }
  };

  typeText = (value, tableMeta) => {
    let is_signup = tableMeta.rowData[4];
    if (is_signup === "esign") {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-edit-fill"></em> E-Signature
        </span>
      );
    } else if (is_signup === "accept") {
      return (
        <span className="badge badge-outline-primary">
          <em className="icon ni ni-done"></em> Acceptance only
        </span>
      );
    }
  };

  typeTextArchive = (value, tableMeta) => {
    let is_signup = tableMeta.rowData[3];
    if (is_signup === "esign") {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-edit-fill"></em> E-Signature
        </span>
      );
    } else if (is_signup === "accept") {
      return (
        <span className="badge badge-outline-primary">
          <em className="icon ni ni-done"></em> Acceptance only
        </span>
      );
    }
  };

  defaultText = (value, tableMeta) => {
    let is_default = tableMeta.rowData[2];
    if (is_default === 1) {
      return "Yes";
    } else {
      return "No";
    }
  };

  deleteAlert = async (value) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[9]);
    let id = value;
    this.setState({
      delete_id: id,
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  deleteAgreement = async () => {
    let agreement_id = this.state.delete_id;
    const agreementResponce = await deleteAgreement(
      auth.getAccount(),
      auth.getToken(),
      agreement_id
    );

    //console.log("status: ", agreementResponce.data);
    //$("#btnloader").show();
    if (
      agreementResponce.data.status === 403 ||
      agreementResponce.data.errors === "authentication missing" ||
      agreementResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      agreementResponce.data.status === 404 &&
      agreementResponce.data.message === "fail" &&
      agreementResponce.data.note !== ""
    ) {
      // window.location.replace("/error");
      this.setState({
        errorMessaged: agreementResponce.data.note,
        successMessaged: "",
        disabled: false,
      });
      //$("#btnloader").hide();
    } else if (
      agreementResponce.data.status === 200 &&
      agreementResponce.data.message === "success"
    ) {
      this.setState({
        errorMessaged: "",
        successMessaged: "Agreement deleted successfully.",
        disabled: false,
      });
      //this.componentDidMount();
      setTimeout(function () {
        window.location.reload();
        window.$("#modalDeleteAlert").modal("hide");
      }, 3000);
      //$("#btnloader").hide();
    } else {
      this.setState({
        errorMessaged: agreementResponce.data.message,
        successMessaged: "",
        disabled: false,
      });
      //$("#btnloader").hide();
      //window.location.replace("/error");
    }
  };

  modalHideDel = () => {
    window.$("#modalDeleteAlert").modal("hide");
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  handleChangeStep = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  handleChangeFile = async (event) => {
    this.setState({
      rate_deck_file: event.target.files[0],
    });
    //await this.sendFileData(event.target.files[0]);
  };

  modalHide = () => {
    window.$("#modalAlert").modal("hide");
    // this.props.agreementSigned();
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  onFileChange = (event) => {
    // Update the state
    this.setState({ logo: event.target.files[0] });
  };

  setAgreementDefault = (agreement_accountno, default_value) => {
    //console.log("agreement_accountno: ", agreement_accountno);
    //console.log("default_value: ", default_value);
    let default_title = "Unset Default";
    let default_body_text = `Are you sure you want to unset this agreement as the default? Agreements that are not set as default will not be assigned to newly registered ${localization.suppliersListing.text}.`;
    let default_button_text = "UNSET DEFAULT";
    let default_value_to_change = "duplicate";
    if (default_value === "duplicate") {
      default_title = "Make Default";
      default_body_text = `Are you sure you want to set this agreement as the default? Default agreements will be applied to newly registered ${localization.suppliersListing.text}.`;
      default_button_text = "MAKE DEFAULT";
      default_value_to_change = null;
    }
    this.setState({
      default_action_button: false,
      defaultErrorMessage: "",
      defaultSuccessMessage: "",
      default_title: default_title,
      default_body_text: default_body_text,
      default_button_text: default_button_text,
      default_agreement_accountno: agreement_accountno,
      default_value_to_change: default_value_to_change,
    });
    window.$("#modalMakeDefault").modal("show");
  };

  submitAgreementDefault = async () => {
    const { default_agreement_accountno, default_value_to_change } = this.state;
    this.setState({
      default_action_button: true,
      defaultErrorMessage: "",
      defaultSuccessMessage: "",
    });
    const servicesResponce = await submitAgreementDefaultSupplier(
      auth.getAccount(),
      auth.getToken(),
      default_agreement_accountno,
      default_value_to_change
    );

    //console.log("Agreement Res: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        default_action_button: false,
        defaultErrorMessage:
          "Agreement not found.",
        defaultSuccessMessage: "",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        defaultErrorMessage: "",
        defaultSuccessMessage: "Agreement type updated successfully.",
      });
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    } else {
      this.setState({
        default_action_button: false,
        defaultErrorMessage:
          "There is some error while processing your request.",
        defaultSuccessMessage: "",
      });
      //window.location.replace("/error");
    }
  };

  modalHideRemoveAlert = (modal_id) => {
    window.$("#" + modal_id).modal("hide");
  };

  viewArchivedAgreement = async (agreement_id) => {
    const agreementResponce = await getSupplierAgreement(
      auth.getAccount(),
      auth.getToken(),
      agreement_id,
    );

    if (
      agreementResponce.data.status === 403 ||
      agreementResponce.data.errors === "authentication missing" ||
      agreementResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      agreementResponce.data.status === 200 &&
      agreementResponce.data.message === "success"
    ) {
      this.setState({
        agreement_view:
          agreementResponce.data.data && agreementResponce.data.data.length > 0
            ? agreementResponce.data.data[0][4]
            : "",
        errorMessage: "",
      });
      window.$("#modalViewArchivedAgreement").modal("show");
    } else {
      this.setState({
        errorMessage:
          agreementResponce.data.note ||
          agreementResponce.data.message ||
          "Unable to fetch agreement details.",
      });
    }
  };

  retrieveAlert = (agreement_id) => {
    this.setState({
      retrieve_id: agreement_id,
      retrieveErrorMessage: "",
      retrieveSuccessMessage: "",
      retrieve_action_button: false,
    });
    window.$("#modalRetrieveAlert").modal("show");
  };

  retrieveAgreement = async () => {
    if (this.state.retrieve_action_button === true) {
      return;
    }

    this.setState({
      retrieve_action_button: true,
      retrieveErrorMessage: "",
      retrieveSuccessMessage: "",
    });

    const agreementResponce = await unarchiveSupplierAgreement(
      auth.getAccount(),
      auth.getToken(),
      this.state.retrieve_id,
    );

    if (
      agreementResponce.data.status === 403 ||
      agreementResponce.data.errors === "authentication missing" ||
      agreementResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      agreementResponce.data.status === 200 &&
      agreementResponce.data.message === "success"
    ) {
      this.setState({
        retrieve_action_button: false,
        retrieveErrorMessage: "",
        retrieveSuccessMessage: "Agreement retrieved successfully.",
        successMessage: "Agreement retrieved successfully.",
        errorMessage: "",
      });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      this.setState({
        retrieve_action_button: false,
        retrieveErrorMessage:
          agreementResponce.data.note ||
          agreementResponce.data.message ||
          "Unable to retrieve agreement.",
        retrieveSuccessMessage: "",
      });
    }
  };

  modalHideRetrieve = () => {
    window.$("#modalRetrieveAlert").modal("hide");
  };

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}
          {/* MODAL EDIT PROFILE START */}
          <div className="modal fade" tabIndex="-1" id="modalDeleteAlert">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideDel();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>
                    <h4 className="nk-modal-title">Delete Agreement?</h4>
                    <div className="nk-modal-text">
                      {this.state.errorMessaged !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessaged}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessaged !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessaged}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className="caption-text">
                        Are you sure you want to delete this Agreement?
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHideDel();
                        }}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-danger"
                        onClick={() => {
                          this.deleteAgreement();
                        }}
                      >
                        DELETE
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal fade"
            tabIndex="-1"
            id="modalViewArchivedAgreement"
          >
            <div className="modal-dialog modal-xl" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">View Agreement</h5>
                  <a
                    href="#"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>
                <div className="modal-body">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.agreement_view || "",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="modal fade" tabIndex="-1" id="modalRetrieveAlert">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideRetrieve();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-undo bg-success"></em>
                    <h4 className="nk-modal-title">Retrieve Agreement?</h4>
                    <div className="nk-modal-text">
                      {this.state.retrieveErrorMessage !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.retrieveErrorMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.retrieveSuccessMessage !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.retrieveSuccessMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className="caption-text">
                        Are you sure you want to retrieve this Agreement?
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{
                          cursor: this.state.retrieve_action_button
                            ? "not-allowed"
                            : "pointer",
                          pointerEvents: this.state.retrieve_action_button
                            ? "none"
                            : "auto",
                          opacity: this.state.retrieve_action_button ? 0.6 : 1,
                        }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHideRetrieve();
                        }}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      {this.state.retrieve_action_button === true ? (
                        <button
                          className="btn btn-lg btn-mw btn-success"
                          type="button"
                          disabled
                        >
                          <span
                            className="spinner-grow spinner-grow-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> PROCESSING... </span>
                        </button>
                      ) : (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-success"
                          onClick={() => {
                            this.retrieveAgreement();
                          }}
                        >
                          RETRIEVE
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* MSA WARNING END */}
          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <h3 className="nk-block-title page-title">
                  <PageTitle
                    name={`${localization.suppliersListing.text} Agreements`}
                    icon="icon ni ni-reports-alt"
                  />
                </h3>
              </div>
              <div className="nk-block-head-content" id="HeadContent">
                {this.state.permissionsState &&
                this.state.permissionsState.length > 0 &&
                this.state.permission_add_agreement === 1 ? (
                  <div className="toggle-wrap nk-block-tools-toggle">
                    <a
                      href="#"
                      className="btn btn-icon btn-trigger toggle-expand mr-n1"
                      data-target="pageMenu"
                    >
                      <em className="icon ni ni-more-v"></em>
                    </a>
                    <div
                      className="toggle-expand-content"
                      data-content="pageMenu"
                    >
                      <ul className="nk-block-tools g-3">
                        <li className="nk-block-tools-opt">
                          <Link
                            color="inherit"
                            onClick={() =>
                              this.addMenuHistory("/suppliers/addagreement")
                            }
                            className="btn btn-primary"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              color: "#fff",
                            }}
                          >
                            <em className="icon ni ni-plus-round"></em>
                            &nbsp;Add New Agreement
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="nk-block">
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  data-toggle="tab"
                  href="#tabItem1"
                >
                  {`${localization.suppliersListing.text} Agreements`}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-toggle="tab"
                  href="#tabItem2"
                  onClick={this.SupplierAgreementsArchivedFun}
                >
                  Archived
                </a>
              </li>
            </ul>
            {/* Table 5th Col Start */}
            <div className="tab-content">
              <div className="tab-pane active" id="tabItem1">
                <div className="row g-gs">
                  <div className="col-xxl-12">
                    {this.state.errorMessage !== "" ? (
                      <div className="example-alert">
                        <div className="alert alert-pro alert-danger">
                          <div className="alert-text">
                            <h4>Error</h4>
                            <p>{this.state.errorMessage}</p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {this.state.successMessage !== "" ? (
                      <div className="example-alert">
                        <div className="alert alert-pro alert-success">
                          <div className="alert-text">
                            <h4>Success</h4>
                            <p>{this.state.successMessage}</p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div className="nk-block nk-block-lg">
                      {/* START DATATABLE */}
                      {this.state.tableLoader === true ? (
                        tableLoader()
                      ) : (
                        <DataTable
                          columns={this.state.columns}
                          tableData={this.state.agreementsData}
                          title={`${localization.suppliersListing.text} Agreements`}
                        />
                      )}

                      {/* END TABLE */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane " id="tabItem2">
                <div className="row g-gs">
                  <div className="col-xxl-12">
                    {this.state.errorMessage !== "" ? (
                      <div className="example-alert">
                        <div className="alert alert-pro alert-danger">
                          <div className="alert-text">
                            <h4>Error</h4>
                            <p>{this.state.errorMessage}</p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {this.state.successMessage !== "" ? (
                      <div className="example-alert">
                        <div className="alert alert-pro alert-success">
                          <div className="alert-text">
                            <h4>Success</h4>
                            <p>{this.state.successMessage}</p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div className="nk-block nk-block-lg">
                      {/* START DATATABLE */}
                      {this.state.tableLoader === true ? (
                        tableLoader()
                      ) : (
                        <DataTableExtended
                          columns={this.state.columnsExtended}
                          tableData={this.state.archivedagreementsData}
                          title="Archived Agreements"
                        />
                      )}

                      {/* END TABLE */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Table 5th Col End */}
          </div>
          {/*<div className="nk-block">
           
            <div className="row g-gs">
              <div className="col-xxl-12">
                {this.state.errorMessage !== "" ? (
                  <div className="example-alert">
                    <div className="alert alert-pro alert-danger">
                      <div className="alert-text">
                        <h4>Error</h4>
                        <p>{this.state.errorMessage}</p>
                      </div>
                    </div>
                  </div>
                ) : null}
                {this.state.successMessage !== "" ? (
                  <div className="example-alert">
                    <div className="alert alert-pro alert-success">
                      <div className="alert-text">
                        <h4>Success</h4>
                        <p>{this.state.successMessage}</p>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="nk-block nk-block-lg">
                 
                  {this.state.tableLoader === true ? (
                    tableLoader()
                  ) : (
                    <DataTable
                      columns={this.state.columns}
                      tableData={this.state.agreementsData}
                      title="Channel Partner Agreements"
                    />
                  )}

                 
                </div>
              </div>
            </div>
            
          </div>*/}
          {/* Default Modal Start */}
          <div className="modal fade" tabIndex="-1" id="modalMakeDefault">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em
                      className="icon ni ni-alert-circle"
                      style={{ fontSize: "3rem" }}
                    ></em>

                    <h4 className="nk-modal-title">
                      {this.state.default_title}
                    </h4>
                    {this.state.defaultErrorMessage !== "" ? (
                      <div className="alert alert-pro alert-danger mb-4">
                        <div className="alert-text">
                          <h6>Error</h6>
                          <p>{this.state.defaultErrorMessage}</p>
                        </div>
                      </div>
                    ) : null}
                    {this.state.defaultSuccessMessage !== "" ? (
                      <div className="alert alert-pro alert-success mb-4">
                        <div className="alert-text">
                          <h6>Success</h6>
                          <p>{this.state.defaultSuccessMessage}</p>
                        </div>
                      </div>
                    ) : null}
                    <div className="nk-modal-text">
                      <div className="caption-text">
                        {this.state.default_body_text}
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      {this.state.default_action_button === true ? (
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled
                        >
                          <span
                            className="spinner-grow spinner-grow-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> Processing... </span>
                        </button>
                      ) : (
                        <>
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-light"
                            onClick={() => {
                              this.modalHideRemoveAlert("modalMakeDefault");
                            }}
                            disabled={this.state.disabled}
                          >
                            CLOSE
                          </a>
                          {"  "}
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.submitAgreementDefault();
                            }}
                            disabled={this.state.disabled}
                          >
                            {this.state.default_button_text}
                          </a>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Default Modal End */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
    userRoleItems: state.userRoleItems,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Agentagreement);
